import {
    GET_USER_SETTINGS, REFRESH_SETTINGS, LEFT_SIDE_MENU_TOGGLE, GET_USER_CONFIGURATION,
    POST_FILE_UPLOADING, POST_FILE_UPLOAD_ON_SUCCESS, POST_FILE_UPLOAD_ON_FAILTURE, CLEAR_POST_FILE_UPLOAD,
    GET_USER_FARM_CONFIGURATION, GET_USER_FARM_CONFIGURATION_REQUEST
} from '../constants/action-types';
import { capitalize } from '../helpers/common';
import { setSettings, getSettings } from '../helpers/session';
import { Unit } from '../helpers/unit';

const initialState = {
    userSettings: {},
    settings: {
        isRequest: false,
        speedShortName: 'mph',
        areaShortName: 'Acres',
        weightShortName: 'lbs',
        distanceShortName: 'miles',
        speedGetExp: null,
        areaGetExp: null,
        weightGetExp: null,
        speedSetExp: null,
        areaSetExp: null,
        weightSetExp: null,
        mapDisplayId: 1,
        dailySummaryEmail: 0
    },
    leftSideMenu: {
        show: true
    },
    configuration: {},

    fileUpload: {
        isUploading: false,
        url: '',
    },
    farmConfiguration: {
        isRequesting: false,
        payload: {}
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_SETTINGS:
            const userSettings = action.payload ? action.payload : initialState.userSettings;
            const settings = action.payload ? parseSettings(action.payload) : initialState.settings;
            state = { ...state, userSettings, settings };
            setSettings(state.settings);
            Unit.getInstance().setUnit(state.settings);
            break;
        case REFRESH_SETTINGS:
            state = { ...state, settings: getSettings() };
            Unit.getInstance().setUnit(state.settings);
            break;
        case LEFT_SIDE_MENU_TOGGLE:
            state = { ...state, leftSideMenu: { ...state.leftSideMenu, show: !state.leftSideMenu.show } };
            break;
        case GET_USER_CONFIGURATION:
            if (!action.name) break;
            state = {
                ...state,
                configuration: {
                    ...state.configuration,
                    [action.name]: {
                        ...state.configuration[action.name],
                        ...action.payload ? action.payload : {}
                    }
                }
            };
            break;
        // file upload 
        case POST_FILE_UPLOADING: {
            state = {
                ...state,
                fileUpload: {
                    ...state.fileUpload, isUploading: true, url: ''
                }
            };
            break;
        }
        case POST_FILE_UPLOAD_ON_SUCCESS: {
            state = {
                ...state,
                fileUpload: {
                    ...state.fileUpload, isUploading: false, url: action.payload.url
                }
            };
            break;
        }
        case POST_FILE_UPLOAD_ON_FAILTURE:
        case CLEAR_POST_FILE_UPLOAD: {
            state = {
                ...state,
                fileUpload: {
                    ...state.fileUpload,
                    ...initialState.fileUpload
                }
            }
            break;
        }
        case GET_USER_FARM_CONFIGURATION: {
            state = {
                ...state,
                farmConfiguration: {
                    isRequesting: false,
                    payload: action.payload
                }
            }
            break;
        }
        case GET_USER_FARM_CONFIGURATION_REQUEST: {
            state = {
                ...state,
                farmConfiguration: {
                    ...state.farmConfiguration.payload,
                    isRequesting: true
                }
            }
            break;
        }
        default:
            break;
    }
    return state;
}

const parseSettings = (settings) => {
    return {
        speedShortName: settings.speed ? settings.speed.short_name : null,
        areaShortName: settings.area ? capitalize(settings.area.short_name) : null,
        weightShortName: settings.weight ? settings.weight.short_name : null,
        distanceShortName: settings.distance ? settings.distance.short_name : null,
        speedGetExp: settings.speed ? settings.speed.get_expression : null,
        areaGetExp: settings.area ? settings.area.get_expression : null,
        weightGetExp: settings.weight ? settings.weight.get_expression : null,
        distanceGetExp: settings.distance ? settings.distance.get_expression : null,
        speedSetExp: settings.speed ? settings.speed.set_expression : null,
        areaSetExp: settings.area ? settings.area.set_expression : null,
        weightSetExp: settings.weight ? settings.weight.set_expression : null,
        distanceSetExp: settings.distance ? settings.distance.set_expression : null,
        mapDisplayId: settings.map_display_settings ? settings.map_display_settings.id : null
    }
}
